<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/checkbox.vue'

export default FormElement;
</script>